'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.markBoardResourcesAsStale = undefined;

var _resourceActions = require('../../utils/services/http/resources/resourceActions');

var _resourceConstants = require('../../utils/services/http/resources/resourceConstants');

// Action Creators
var markBoardResourcesAsStale = exports.markBoardResourcesAsStale = (0, _resourceActions.makeResourceStaleActionCreator)(_resourceConstants.RESOURCE_TYPES.boards);

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardActions.js
// module id = 1952
// module chunks = 0